// ─── Money Formatter ─────────────────────────────────────────────────────────

var ScrubdFormatMoney = function (cents) {
  var format = document.getElementById('money-format')?.value;
  if (!format) return '';

  if (typeof cents === 'undefined' || cents === null) return '';
  if (typeof cents === 'string' && cents.length === 0) return '';

  var value = '',
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format;

  if (typeof cents === 'string') cents = cents.replace('.', '');

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number === null) return 0;

    number = (number / 100).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      centsPart = parts[1] ? decimal + parts[1] : '';

    return dollars + centsPart;
  }

  var match = formatString.match(placeholderRegex);
  if (!match) return '';

  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};

// ─── Reward Bar ───────────────────────────────────────────────────────────────

const threshold = window.cartThreshold || 0;

function updateRewardBar(cartTotal) {
  const remaining = threshold - cartTotal;
  const progressPercent = Math.min((cartTotal / threshold) * 100, 100);
  const progressLine = document.querySelector('.reward-progress-line');
  const rewardText   = document.querySelector('.main-cart-reward-text p');

  if (!progressLine || !rewardText) return;

  progressLine.style.width = progressPercent + '%';

  if (cartTotal >= threshold) {
    rewardText.innerHTML = '<strong>🎉 Doprava zdarma odemčena!</strong>';
    progressLine.style.background = '#7c3fba';
  } else {
    const remainingFormatted = ScrubdFormatMoney(remaining);
    rewardText.innerHTML =
      'Chybí už jen <span class="cart-reward-price">' +
      remainingFormatted +
      '</span> a máš <strong>dopravu zdarma 📦</strong>';
  }
}


function updateCartUI(cartData) {
  if (cartData) {
    const priceEl = document.querySelector('.checkout-total-price');
    if (priceEl) priceEl.innerHTML = ScrubdFormatMoney(cartData.total_price);
    updateRewardBar(cartData.total_price);
  } else {
    // Fallback fetch
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const priceEl = document.querySelector('.checkout-total-price');
        if (priceEl) priceEl.innerHTML = ScrubdFormatMoney(cart.total_price);
        updateRewardBar(cart.total_price);
      })
      .catch((e) => console.error('[RewardBar] Cart fetch error:', e));
  }
}

// ─── Initial Load ─────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {

  const progressLine = document.querySelector('.reward-progress-line');
  if (progressLine) progressLine.style.width = '0%';

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const priceEl = document.querySelector('.checkout-total-price');
      if (priceEl) priceEl.innerHTML = ScrubdFormatMoney(cart.total_price);
      updateRewardBar(cart.total_price);
    })
    .catch((e) => console.error('[RewardBar] Initial cart fetch error:', e));

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.cartData) {
        // cartData directly available — no extra fetch needed
        updateCartUI(event.cartData);
      } else {
        // Fallback fetch
        updateCartUI();
      }
    });

  } else {

    // ─── MutationObserver Fallback (non-Dawn themes) ──────────────────────────

    const cartContainer =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');

    if (cartContainer) {
      const observer = new MutationObserver(function () {
        updateCartUI();
      });
      observer.observe(cartContainer, { childList: true, subtree: true });
    }

  }

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.quantity__button') ||
      e.target.closest('cart-remove-button')
    ) {
      if (typeof subscribe === 'undefined') {
        updateCartUI();
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('quantity__input')) {
      if (typeof subscribe === 'undefined') {
        updateCartUI();
      }
    }
  });

});